// frontend/src/components/EmpresaPortal/PruebasPersonalizadas.js
//
// "Crea tu propia prueba" (estilo Microsoft Forms): la empresa arma su
// propio cuestionario para luego combinarlo en un stack, junto con las
// pruebas oficiales de PsyTest si así lo desea. El constructor en sí vive en
// su propia página (ver ConstructorPrueba.js) — aquí solo se lista/gestiona.

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Pencil, Trash2, FileText } from 'lucide-react';

const PruebasPersonalizadas = ({ onCambio }) => {
  const navigate = useNavigate();
  const [pruebas, setPruebas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { cargarPruebas(); }, []);

  const cargarPruebas = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/empresas/me/pruebas', { credentials: 'include' });
      const data = await res.json();
      setPruebas(Array.isArray(data) ? data : []);
    } catch (e) { /* lista queda vacía */ }
    setLoading(false);
  };

  const handleEliminar = async (prueba) => {
    if (!window.confirm(`¿Eliminar la prueba "${prueba.nombre}"? Esta acción no se puede deshacer.`)) return;
    try {
      const res = await fetch(`/api/empresas/me/pruebas/${prueba.id}`, { method: 'DELETE', credentials: 'include' });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      await cargarPruebas();
      if (onCambio) onCambio();
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="ep-card" data-tour="crear-prueba">
      <div className="ep-card-header">
        <h2>Mis pruebas personalizadas</h2>
        <button type="button" className="ep-btn-primary" onClick={() => navigate('/panel/pruebas/nueva')}><Plus size={15} /> Crear prueba</button>
      </div>
      <p className="ep-hint">
        Crea tus propios cuestionarios (opción única, opción múltiple, texto abierto o escala) para
        combinarlos con las pruebas oficiales en tus stacks.
      </p>

      {loading ? (
        <p className="ep-empty">Cargando...</p>
      ) : pruebas.length === 0 ? (
        <div className="ep-empty-illustration">
          <div className="ep-empty-bubble">
            <FileText size={26} />
            <span className="ep-empty-bubble-badge"><Plus size={12} /></span>
          </div>
          <strong>Aún no has creado ninguna prueba propia.</strong>
          <p>Diseña cuestionarios con opción única, múltiple, texto abierto o escala Likert.</p>
        </div>
      ) : (
        <div className="ep-table-wrap">
          <table className="ep-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Preguntas</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {pruebas.map(p => (
                <tr key={p.id}>
                  <td>{p.nombre}</td>
                  <td>{p.total_reactivos}</td>
                  <td>
                    <div className="ep-row-actions">
                      <button type="button" className="ep-btn-link" onClick={() => navigate(`/panel/pruebas/${p.id}/editar`)}><Pencil size={13} /> Editar</button>
                      <button
                        type="button"
                        className="ep-btn-link ep-btn-link-danger"
                        onClick={() => handleEliminar(p)}
                        disabled={p.en_uso}
                        title={p.en_uso ? 'Está incluida en un stack: quítala de ahí primero' : ''}
                      >
                        <Trash2 size={13} /> Eliminar
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PruebasPersonalizadas;
